if (!customElements.get('tc-floating-video')) {
  customElements.define('tc-floating-video', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.dialog = this.querySelector('[data-video-dialog]');
      this.player = this.querySelector('[data-video-player]');
      this.opener = this.querySelector('[data-video-open]');
      this.closeButton = this.querySelector('[data-video-close]');
      if (!this.dialog || !this.opener) return;
      this.opener.addEventListener('click', () => this.open(), options);
      this.opener.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); this.open(); }
      }, options);
      this.closeButton?.addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.close(); }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); this.close(); }
        if (event.key === 'Tab') {
          const focusable = [...this.dialog.querySelectorAll('button, video[controls], [tabindex="0"]')];
          const first = focusable[0], last = focusable.at(-1);
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
      }, options);
    }
    open() {
      this.dialog.style.display = 'flex';
      document.documentElement.classList.add('video-popup-open');
      document.body.classList.add('video-popup-open');
      this.closeButton?.focus();
      if (this.player) { this.player.muted = false; this.player.currentTime = 0; this.player.play().catch(() => {}); }
    }
    close(restoreFocus = true) {
      if (this.dialog) this.dialog.style.display = 'none';
      if (!document.querySelector('tc-floating-video [data-video-dialog][style*="display: flex"]')) {
        document.documentElement.classList.remove('video-popup-open');
        document.body.classList.remove('video-popup-open');
      }
      if (this.player) { this.player.pause(); this.player.muted = true; }
      if (restoreFocus) this.opener?.focus();
    }
    disconnectedCallback() { this.close(false); this.events?.abort(); }
  });
}
